module.exports = __webpack_public_path__ + "static/img/prev.a0db7110.png";